export const defaultOwnerValue = [{ value: 1, name: 'Owner', langKey: "owner" }];
export const defaultTypeValue = [{ value: 1, name: 'Type', langKey: "type" }];

export const taskTypeSelect = [
    defaultTypeValue[0],
    { value: 2, name: 'Completed tasks', status: 'completed', langKey: "completed-tasks"},
    { value: 3, name: 'Incomplete tasks', status: 'incompleted', langKey: "incomplete-tasks"},
]
